import useFlag from "@cosine/composables/useFlag";
import { FlagKey } from "@cosine/composables/useFlag.types";
import useAuthStore from "@cosine/stores/useAuthStore";
import { addYears } from "date-fns";
import { storeToRefs } from "pinia";
import { computed } from "vue";

export default function () {
  const {
    currentUser,
  } = storeToRefs(useAuthStore());

  const {
    flag: onboardingEnabledAfterSignedUpAt,
  } = useFlag(FlagKey.EnableOnboardingAfterSignedUpAt, addYears(new Date(), 1).toISOString());

  const isOnboardingEnabled = computed(() => {
    return currentUser.value
      && currentUser.value.CreatedAt > onboardingEnabledAfterSignedUpAt.value;
  });

  return {
    isOnboardingEnabled,
  };
}
